import React from 'react';
import SharingSetupModal from '../SharingSetupModal';
import type { SharingSetupProps } from '../types';
import { beautificationInjectableFields } from './injectableFields';
import defaultShareFormYaml from './default_share_form.yaml?raw';

/**
 * Beautification share-message form editor: the shared shell seeded with the
 * beautification form.
 */
const SharingSetup: React.FC<SharingSetupProps> = props => (
  <SharingSetupModal
    {...props}
    defaultShareFormYaml={defaultShareFormYaml}
    injectableFields={beautificationInjectableFields}
  />
);

export default SharingSetup;
